import React from 'react';
import ErrorBoundary from './ErrorBoundary';
import ErrorPage from '../../pages/ErrorPage';

interface ErrorBoundaryWrapperProps {
  children?: React.ReactNode;
}

const ErrorBoundaryWrapper = ({ children }: ErrorBoundaryWrapperProps) => {
  return (
    <ErrorBoundary
      fallback={
        <ErrorPage
          showActionButton={true}
          message=""
        />
      }
    >
      {children}
    </ErrorBoundary>
  );
};

export default ErrorBoundaryWrapper;
